import { render, staticRenderFns } from "./JGisCoord.vue?vue&type=template&id=5d52679c&scoped=true"
import script from "./JGisCoord.vue?vue&type=script&lang=js"
export * from "./JGisCoord.vue?vue&type=script&lang=js"
import style0 from "./JGisCoord.vue?vue&type=style&index=0&id=5d52679c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d52679c",
  null
  
)

export default component.exports